import React, { useMemo } from "react";
import { FieldArray, useField, useFormikContext } from "formik";
import _ from "lodash";
import { useTheme } from "styled-components";
import { Flex, Box } from "reflexbox/styled-components";
import Label from "../Label";
import Button from "../../Button";
import StyledFormikField from "../Field";
import { Helper } from "../../Text";

const EnhancedFieldArray = (props) => {
  const { primary, secondary } = useTheme();
  const {
    errors,
    label,
    description,
    name,
    push,
    remove,
    faProps,
    labelText,
    ...rest
  } = props || {};
  const { setFieldValue } = useFormikContext();

  const [field, meta] = useField(name);

  const fields = useMemo(() => {
    const val = field.value || [""];
    return val;
  }, [field]);

  const filteredRest = _.omit(rest, faProps);

  return (
    <Box width={1}>
      <Label>{label || labelText}</Label>
      <Helper mb="0.5rem">{description}</Helper>
      {fields?.map((value, i) => {
        return (
          <Flex width={1} mb="1rem" key={`${name}.${i}`} alignItems="center">
            <Box width={1} mb="-1rem" mr="1rem">
              <StyledFormikField
                id={`${name}.${i}`}
                noLabel
                key={`${name}.${i}`}
                type="text"
                onChange={(e) => setFieldValue(`${name}.${i}`, e.target.value)}
                name={`${name}.${i}`}
                error={meta.error}
                {...filteredRest}
              />
            </Box>
            {i === fields.length - 1 && (
              <Button
                color={primary}
                iconName="faPlus"
                onClick={() => push("")}
              />
            )}
            {fields.length !== 1 && (
              <Button
                color={secondary}
                iconName="faMinus"
                onClick={() => remove(i)}
              />
            )}
          </Flex>
        );
      })}

      {fields.length === 0 ? (
        <Button color={primary} iconName="faPlus" onClick={() => push("")} />
      ) : null}
    </Box>
  );
};

const FieldArrayHOC = (props) => (
  <FieldArray
    {...props}
    render={(faProps) => (
      <EnhancedFieldArray {...props} {...faProps} faProps={_.keys(faProps)} />
    )}
  />
);

export default FieldArrayHOC;
